export default {
      id: "i-active-protection-usage",
      viewBox: "0 0 55 55",
      url: __webpack_public_path__ + "img/sprite.svg#i-active-protection",
      toString: function () {
        return this.url;
      }
    }